<template>
  <CustomBottomSheet
    :refName="'filterSheet'"
    size="lg"
    :headerText="$t('filter')"
    :headerIcon="icon"
  >
    <div class="row">
      <CustomSelectBox
        :className="'col-md-12'"
        :id="`categoryToken`"
        :value="filterData.categoryToken"
        :options="categoryTokenOptions"
        v-on:changeValue="filterData.categoryToken = $event"
        :title="$t('Categories.select')"
        :imgName="'categories.svg'"
      />
      <CustomInputFloat
        :className="'col-md-6'"
        :id="`productPriceFrom`"
        :value="filterData.productPriceFrom"
        v-on:changeValue="filterData.productPriceFrom = $event"
        :title="$t('general.priceFrom')"
        :imgName="'money.svg'"
      />
      <CustomInputFloat
        :className="'col-md-6'"
        :id="`productPriceTo`"
        :value="filterData.productPriceTo"
        v-on:changeValue="filterData.productPriceTo = $event"
        :title="$t('general.priceTo')"
        :imgName="'money.svg'"
      />
    </div>
    <CustomBaseEntityFilter
      :className="'row'"
      :value="filterData"
      v-on:changeValue="filterData.fillData($event)"
    />

    <div class="form-actions">
      <div class="icon-submit" @click.prevent="search">
        <img src="@/assets/images/search-icon.svg" :title="$t('search')" />
      </div>
      <div @click.prevent="closeBottomSheet('filterSheet')" class="icon-cancel">
        <img src="@/assets/images/cancel-icon.svg" :title="$t('cancel')" />
      </div>
    </div>
  </CustomBottomSheet>
</template>

<script>
import CustomBottomSheet from "./../../../../../components/general/CustomBottomSheet.vue";
import CustomSelectBox from "./../../../../../components/general/CustomSelectBox.vue";
import CustomInputFloat from "./../../../../../components/general/CustomInputFloat.vue";
import CustomBaseEntityFilter from "./../../../../../components/general/CustomBaseEntityFilter.vue";
import generalMixin from "./../../../../../utils/generalMixin";
import { getCategoriesDialog } from "./../../../../../utils/dialogsOfApi";
import icon from "@/assets/images/filter.svg";

export default {
  mixins: [generalMixin],
  props: {
    theFilterData: {
      type: Object,
    },
  },
  data() {
    return {
      filterData: this.theFilterData,
      categoryTokenOptions: [],
      icon,
    };
  },
  components: {
    CustomBottomSheet,
    CustomSelectBox,
    CustomInputFloat,
    CustomBaseEntityFilter,
  },
  methods: {
    async getCategoriesDialog() {
      this.isLoading = true;
      this.categoryTokenOptions = await getCategoriesDialog();
      this.isLoading = false;
    },
    search() {
      this.closeBottomSheet("filterSheet");
      this.$emit("search", this.filterData);
    },
  },
  created() {
    this.getCategoriesDialog();
  },
};
</script>
